import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';

const Feature = ({ title, description, image, direction = "stacked", rounded = false }) => {
	const imgClasses = rounded ? 'border-rounded' : '';
	const isStacked = direction === 'stacked';
	return (
		<div className={`feature ${direction === 'stacked' ? 'feature-stacked' : 'feature-inline'}`}>
			{
				image !== undefined &&
				(
					<LazyLoad once={ true } offset={ 200 }>
						<img
							src={ image }
							alt={ title }
							className={ imgClasses }
						/>
					</LazyLoad>
				)
			}
			<div>
				<h3 className="feature-title">
					{ title }
				</h3>
				<p>
					{ description }
				</p>
			</div>
		</div>
	);
};

Feature.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	image: PropTypes.string.isRequired,
	direction: PropTypes.oneOf(['stacked', 'inline']),
	rounded: PropTypes.bool
};

export default Feature;


// WEBPACK FOOTER //
// ./src/pages/common/Feature.js